// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"9":"fb1a9cb710ec7a1a","666":"ee4dd181168bbafe","793":"42ef63b7ec463244"}[chunkId] + ".js";
};